import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FiltrosDocumentosService {
  private storageKey = 'filtrosDocumentos';

  get filtros() {
    const stored = sessionStorage.getItem(this.storageKey);
    return stored ? JSON.parse(stored) : {
      organization: '',
      responsible: '',
      status: '',
      searchText: ''
    };
  }

  set filtros(value) {
    sessionStorage.setItem(this.storageKey, JSON.stringify(value));
  }

  limpiarFiltros() {
    sessionStorage.removeItem(this.storageKey);
  }

  constructor() { }
}
